import { Resource } from '@/modules/backend/Entities/Resource';
import { Type } from 'class-transformer';
import { Location as RouterLocation } from 'vue-router/types/router';

export class Company {
  private id!: number;
  private name!: string;
  private email!: string;
  @Type(() => Resource)
  private resources!: Resource[];

  public getId(): number {
    return this.id;
  }

  public getCompoundId(): number {
    return this.getId();
  }

  public getName(): string {
    return this.name;
  }

  public getEmail(): string {
    return this.email;
  }

  public getResources(): Resource[] {
    return this.resources || [];
  }

  public changeName(name: string): void {
    this.name = name;
  }

  public changeEmail(email: string): void {
    this.email = email;
  }

  public getRouteLocation(): RouterLocation {
    return {
      name: 'dashboard.company.buildings',
      params: {
        companyId: String(this.getId()),
      },
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public merge<T = any>(object: any): T {
    return {
      ...this,
      ...object
    } as T;
  }
}
